import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    // console.log("error; ", error.message); 

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-customDark">
            <h1 className="text-4xl font-bold text-red-500 mb-4">Oops!</h1>
            <p className="text-lg text-gray-300 mb-2">Something went wrong.</p>
            <p className="text-md text-gray-200 mb-6">
                {error?.message === "Network Error" ? "Network Failed 🛜" : 'We encountered an unexpected error 😥😥'}
            </p>
            <a
                href="/"
                className="bg-customGold text-white px-6 py-2 rounded-md hover:opacity-70 transition"
            >
                Go Home
            </a>
        </div>
    );
}
